import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Twitter, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
    return (
        <footer
            className="relative bg-[#F7F7F8] border-t border-[#E8E8EC] pt-20 pb-10"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-14">
                    {/* Brand */}
                    <div className="md:col-span-5">
                        <Link to="/" className="inline-flex items-center mb-5" data-testid="footer-logo" aria-label="RevoloAIWEB — home">
                            <img
                                src="/logo.png"
                                alt="RevoloAIWEB"
                                className="h-14 w-auto select-none"
                                draggable="false"
                            />
                        </Link>
                        <p className="text-[#4A4A5A] text-[15px] leading-relaxed max-w-md">
                            A UK-based agency at the intersection of web development and
                            AI-powered security. We build, launch, and protect your most
                            important digital asset.
                        </p>
                        <div className="mt-6 flex items-center gap-2">
                            {[
                                { icon: Mail, href: 'mailto:hello@revoloaiweb.com', label: 'Email', id: 'mail' },
                                { icon: Github, href: 'https://github.com', label: 'GitHub', id: 'github' },
                                { icon: Twitter, href: 'https://twitter.com', label: 'Twitter', id: 'twitter' },
                                { icon: Linkedin, href: 'https://linkedin.com', label: 'LinkedIn', id: 'linkedin' },
                            ].map((s) => (
                                <a
                                    key={s.id}
                                    href={s.href}
                                    target={s.href.startsWith('http') ? '_blank' : undefined}
                                    rel="noopener noreferrer"
                                    className="p-2.5 rounded-lg bg-white border border-[#E8E8EC] text-[#4A4A5A] hover:text-[#7B61FF] hover:border-[#7B61FF]/40 transition-all"
                                    data-testid={`footer-social-${s.id}`}
                                    aria-label={s.label}
                                >
                                    <s.icon className="w-4 h-4" />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Site map */}
                    <div className="md:col-span-3">
                        <h4 className="text-[12px] font-semibold uppercase tracking-[0.15em] text-[#6B6B7A] mb-4">
                            Pages
                        </h4>
                        <ul className="space-y-3 text-[14px]">
                            {['Home', 'Services', 'Pricing', 'Portfolio'].map((l) => (
                                <li key={l}>
                                    <Link
                                        to={l === 'Home' ? '/' : `/${l.toLowerCase()}`}
                                        className="text-[#4A4A5A] hover:text-[#7B61FF] transition-colors"
                                        data-testid={`footer-link-${l.toLowerCase()}`}
                                    >
                                        {l}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="md:col-span-2">
                        <h4 className="text-[12px] font-semibold uppercase tracking-[0.15em] text-[#6B6B7A] mb-4">
                            Company
                        </h4>
                        <ul className="space-y-3 text-[14px]">
                            {['Security', 'About', 'FAQ', 'Contact'].map((l) => (
                                <li key={l}>
                                    <Link
                                        to={`/${l.toLowerCase()}`}
                                        className="text-[#4A4A5A] hover:text-[#7B61FF] transition-colors"
                                        data-testid={`footer-link-${l.toLowerCase()}`}
                                    >
                                        {l}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-[12px] font-semibold uppercase tracking-[0.15em] text-[#6B6B7A] mb-4">
                            Contact
                        </h4>
                        <ul className="space-y-3 text-[14px]">
                            <li>
                                <a
                                    href="mailto:hello@revoloaiweb.com"
                                    className="text-[#4A4A5A] hover:text-[#7B61FF] transition-colors"
                                    data-testid="footer-email"
                                >
                                    hello@revoloaiweb.com
                                </a>
                            </li>
                            <li className="text-[#4A4A5A]">United Kingdom</li>
                            <li className="text-[#4A4A5A]">Mon–Fri · 9–6 GMT</li>
                        </ul>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="pt-8 border-t border-[#E8E8EC] flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
                    <p className="text-[#6B6B7A] text-[13px]">
                        © 2026 REVOLO AI WEB · All rights reserved.
                    </p>
                    <div className="flex items-center gap-6 text-[13px] text-[#6B6B7A]">
                        <a href="#" className="hover:text-[#1A1A2E] transition-colors" data-testid="footer-privacy">
                            Privacy Policy
                        </a>
                        <a href="#" className="hover:text-[#1A1A2E] transition-colors" data-testid="footer-terms">
                            Terms of Service
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
